/**
 * MEGOSZTAS AZ AVSLACKBE mas appokbol (versenyaudit K2, Android).
 *
 * A telefon "Megosztas" menujeben a telepitett AVSlack is megjelenik
 * (manifest `share_target`). A megosztott szoveget es fajlokat a service
 * worker veszi at, es egy gyorsitotarba teszi (`sw.js`, `/megosztas`), majd
 * az appot a `?megosztas=1` cimmel nyitja meg. Innen:
 *
 *  1. `takeSharedItems()` kiolvassa es TORLI a gyorsitotarbol - egy
 *     megosztas egyszer hasznalhato fel, ujratolteskor nem jon vissza,
 *  2. a felhasznalo csatornat valaszt (ShareTargetDialog),
 *  3. `stagePendingShare()` felirja, mi menjen melyik csatornaba, es a
 *     csatorna szerkesztoje (`Composer`) betolti: szoveg a mezobe, fajlok a
 *     csatolmanyok koze. ELKULDENI a felhasznalo kuldi el - atnezheti.
 */

const CACHE = 'avslack-share';

export interface SharedItems {
  text: string;
  files: File[];
}

export async function takeSharedItems(): Promise<SharedItems | null> {
  if (typeof caches === 'undefined') return null;
  try {
    const cache = await caches.open(CACHE);
    const meta = await cache.match('/megosztas/adat');
    if (!meta) return null;
    const data = (await meta.json()) as {
      title?: string;
      text?: string;
      url?: string;
      files?: number;
    };

    const files: File[] = [];
    for (let index = 0; index < (data.files ?? 0); index += 1) {
      const response = await cache.match(`/megosztas/fajl/${index}`);
      if (!response) continue;
      const blob = await response.blob();
      const name = decodeURIComponent(response.headers.get('x-name') ?? `fajl-${index}`);
      files.push(new File([blob], name, { type: blob.type }));
    }

    await caches.delete(CACHE);

    // A cim, a szoveg es a link kulon mezoben jon; egy uzenetbe fuzzuk, ismetles nelkul.
    const parts: string[] = [];
    for (const part of [data.title, data.text, data.url]) {
      const clean = part?.trim();
      if (clean && !parts.some((existing) => existing.includes(clean))) parts.push(clean);
    }
    return { text: parts.join('\n'), files };
  } catch {
    return null;
  }
}

let pending: { channelId: string; items: SharedItems } | null = null;

export function stagePendingShare(channelId: string, items: SharedItems): void {
  pending = { channelId, items };
}

/** A csatorna szerkesztoje egyszer veszi at - utana eltunik. */
export function takePendingShare(channelId: string): SharedItems | null {
  if (!pending || pending.channelId !== channelId) return null;
  const items = pending.items;
  pending = null;
  return items;
}
